import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/badge";

import { StockStatus, StockStatusCode } from "../../DepositCard/deposit-dtos";

const STATUS_VARIANTS: Record<StockStatusCode, "success" | "warning" | "default" | "destructive"> =
  {
    FOR_SALE: "success",
    SALE_PENDING: "warning",
    SOLD: "default",
    REMOVED: "destructive",
  };

export const stockStatusLabelKey = (status: StockStatus): string =>
  status.code === "REMOVED" && status.is_outside_farm2go && !status.is_removed
    ? "farmersMarket.stockStatus.OUTSIDE_FARM2GO"
    : `farmersMarket.stockStatus.${status.code}`;

export const StockStatusBadges = ({ status }: { status: StockStatus }) => {
  const { t } = useTranslation();

  return (
    <>
      <Badge variant={STATUS_VARIANTS[status.code]}>{t(stockStatusLabelKey(status))}</Badge>
      {status.is_edited && <Badge variant="outline">{t("farmersMarket.stockStatus.EDITED")}</Badge>}
      {status.is_split && <Badge variant="outline">{t("farmersMarket.stockStatus.SPLIT")}</Badge>}
    </>
  );
};

export const StockStatusCodeBadge = ({ code }: { code: StockStatusCode }) => {
  const { t } = useTranslation();

  return <Badge variant={STATUS_VARIANTS[code]}>{t(`farmersMarket.stockStatus.${code}`)}</Badge>;
};
